import { Button, PlusIcon } from "melco-ui";
import { Key } from "react";
import { useTranslation } from "react-i18next";
import { ReportingMelcoMachineStatisticsModelsGroupListItem } from "melco-shared-logic";

export type BulkActionAddFilterMachineGroupsProps = {
  allMachineGroups?: ReportingMelcoMachineStatisticsModelsGroupListItem[];
  selectedRowKeys: Key[];
  setSelectedRowKeys: (keys: Key[]) => void;
  setMachineGroupsFilter: any;
  machineGroupsFilter: any;
};

export const BulkActionAddFilterMachineGroups: React.FC<
  BulkActionAddFilterMachineGroupsProps
> = ({
  allMachineGroups,
  selectedRowKeys,
  setSelectedRowKeys,
  setMachineGroupsFilter,
  machineGroupsFilter,
}) => {
  const { t } = useTranslation();

  const isFilterAlreadyAdded = (id: string) => {
    return machineGroupsFilter?.find((c: any) => c.value == id);
  };

  const addGroups = (toAdd: any[]) => {
    const addedGroups = toAdd
      .filter((c) => !isFilterAlreadyAdded(c.id))
      .map((group) => {
        const { name, id } = group;
        return {
          label: name,
          value: id,
        };
      });

    setMachineGroupsFilter([...(machineGroupsFilter ?? []), ...addedGroups]);
    return addedGroups;
  };

  return (
    <>
      {selectedRowKeys.length > 0 && (
        <Button
          icon={<PlusIcon />}
          onClick={() => {
            if (allMachineGroups) {
              const machineGroupsToAdd = allMachineGroups.filter((c: any) => {
                return selectedRowKeys.includes(c.id!);
              });

              addGroups(machineGroupsToAdd);
              setSelectedRowKeys([]);
            }
          }}
        >
          {t("reporting.statistics.filters.machineGroup.add.add_selected")}
        </Button>
      )}
    </>
  );
};
